var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation-item-popover"},[_c('div',{staticClass:"navigation-item-popover__title"},[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_vm._v(" "),(_vm.items.length)?_c('NavigationSubItems',{staticClass:"navigation-item-popover__sub-menu",attrs:{"items":_vm.items}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }